// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__10Wr_","footer":"ReportModalFilter_footer__3FBbI"};